import {
  REACT_APP_API,
  REACT_APP_API_SF,
  REACT_APP_PERITADOR_API,
  // REACT_APP_PRICING_API,
  REACT_APP_API_ABM_FW
} from './config'

// @deprecated. deberíamos usar BFFAgent
export const DATAMASTER_ENDPOINT = REACT_APP_API + '/datamasters'
export const CLIENTES_ENDPOINT = REACT_APP_API + '/clients'
export const CATALOGO_ENDPOINT = REACT_APP_API + '/catalogs'
export const LEADS_ENDPOINT = REACT_APP_API + '/leads'
export const LEADSORIGIN_ENDPOINT = REACT_APP_API + '/leadsorigins'
export const PAYMENT_ENDPOINT = REACT_APP_API + '/pagos'
export const FILES_ENDPOINT = REACT_APP_API + '/files/associations'
export const PRESUPUESTADOR_ENDPOINT = REACT_APP_API + '/budgets'
export const STOCKS_ENDPOINT = REACT_APP_API + '/stocks'
export const SALES_ENDPOINT = REACT_APP_API + '/sales'
export const BILLS_ENDPOINT = REACT_APP_API + '/bills'
export const MONTHLY_COMMISSIONS_ENDPOINT = REACT_APP_API + '/commissionsPeriods'
export const COMMISSIONS_ENDPOINT = REACT_APP_API + '/commissionPolicies'
export const FAIR_PRICE_ENDPOINT = REACT_APP_API + '/fairPrice'
export { REACT_APP_API_SF, REACT_APP_PERITADOR_API, REACT_APP_API_ABM_FW }
export const PRICE_VERSION_VARIATION_ENDPOINT = REACT_APP_API + '/versionVariation'
export const PRICE_VERSION_VARIATION_VERSION_ENDPOINT = REACT_APP_API + '/versionVariation/version'
export const PRICE_VERSION_VARIATION_DRAFT_BY_DEPRECIATION = PRICE_VERSION_VARIATION_ENDPOINT + '/draftByDepreciation'
export const PRICE_VERSION_VARIATION_DRAFT_BY_PRICE_DETAIL = PRICE_VERSION_VARIATION_ENDPOINT + '/draftByVersionVariationAndDepreciation'
export const SAVINGS_PLAN_ENDPOINT = REACT_APP_API + '/savings-plans'
export const SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT = REACT_APP_API + '/savings-plans-subscriptions'
export const NOTIFICATION_ENDPOINT = REACT_APP_API + '/notifications'